import React, { useState, forwardRef, useCallback } from 'react';

import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

type Props = {
  Variant: string;
  handleOnClose?: () => void;
  message: any;
} & SnackbarProps;

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} {...props} />;
});

export default function SnackBarNotification(prop: Props) {
  const { Variant, handleOnClose, message, ...others } = prop;
  const [snackBarState, setSnackBarState] = useState(true);

  const handleToClose = useCallback(
    (event: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackBarState(false);

      if (handleOnClose) {
        handleOnClose();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const iff = (condition: any, then: any, otherwise: any) =>
    condition ? then : otherwise;

  return (
    <Snackbar
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={handleToClose}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      anchorOrigin={{
        horizontal: 'center', //For Position changes ;
        vertical: 'top',
      }}
      autoHideDuration={prop?.autoHideDuration ?? 3000}
      onClose={handleToClose}
      open={snackBarState}
      style={{ top: '16px' }} //For Position changes ;
      {...others}
    >
      <Alert
        onClose={handleToClose}
        severity={iff(
          Variant === 'Success',
          'success',
          iff(Variant === 'Failed', 'error', 'info')
        )}
        sx={{ minWidth: '180px' }} //For size changes ;
      >
        {prop.message}
      </Alert>
    </Snackbar>
  );
}
